module.exports = __webpack_public_path__ + "img/activity.096942.svg";